import { Tag } from "features/shared/types/tag";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import { AppThunk } from "services/redux/rootReducer";
// import getProductTableWithoutTags from "features/product/functions/getProductTableWithoutTags";
import { Product } from "features/product/types/product";
import { Article } from "features/article/types/article";
import getArrayOfMaxSizedSubArrays from "features/shared/functions/getArrayOfMaxSizedSubArrays";
import batchOperations from "services/firebase/batchOperations";
import { FIREBASE_ARRAY_CONTAINS_LIMIT } from "services/firebase/constants/limits";
import { ProductTable } from "features/product/types/subproductTable";
import stripTagsFromProductTable from "features/product/functions/stripTagsFromProductTable";

const removeManyTags =
    (keys: Array<Tag["key"]>): AppThunk =>
    async (dispatch) => {
        await batchOperations(async (batch, db, batchedKeys) => {
            const arrayOfKeySubArrays = getArrayOfMaxSizedSubArrays(
                batchedKeys,
                FIREBASE_ARRAY_CONTAINS_LIMIT
            );

            // create sub-arrays of keys to combat firestore's array limit
            await Promise.all(
                arrayOfKeySubArrays.map(async (subArr) => {
                    const relevantProductsQuerySnapshot = await db
                        .collection("products")
                        .where("combinedTags", "array-contains-any", subArr)
                        .get();
                    await Promise.all(
                        relevantProductsQuerySnapshot.docs.map(async (doc) => {
                            const product = doc.data() as Product;
                            const table_batch = db.batch();
                            const tablesSnapshot = await db
                                .collection("products")
                                .doc(doc.id)
                                .collection("tables")
                                .get();

                            tablesSnapshot.docs.forEach((tableDoc) => {
                                const tableRef = tableDoc.ref;
                                table_batch.set(
                                    tableRef,
                                    stripTagsFromProductTable(
                                        tableDoc.data() as ProductTable,
                                        subArr
                                    )
                                );
                            });

                            await table_batch.commit();

                            doc.ref.update({
                                tags: product.tags.filter(
                                    (tagKey: string) => !keys.includes(tagKey)
                                ),
                                combinedTags:
                                    product.combinedTags?.filter(
                                        (tagKey: string) =>
                                            !keys.includes(tagKey)
                                    ) || [],
                            });
                        })
                    );

                    const relevantArticlesQuerySnapshot = await db
                        .collection("articles")
                        .where("tags", "array-contains-any", subArr)
                        .get();
                    relevantArticlesQuerySnapshot.forEach((doc) => {
                        const article = doc.data() as Article;
                        doc.ref.update({
                            tags: article.tags.filter(
                                (tagKey: string) => !keys.includes(tagKey)
                            ),
                        });
                    });
                })
            );

            batchedKeys.forEach((key) => {
                const idRef = db.collection("tags").doc(key);
                batch.delete(idRef);
            });
        }, keys);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Removed tags(s) with keys(s) ${keys.join(
                        ", "
                    )}`,
                },
            })
        );

        return;
    };

export default removeManyTags;
